/**
 * 顧客単価
 */
export class ProductPrice {
    /** 都道府県コード */
    prefectureCode = ""
    /** 顧客コード (999999) */
    code = ""
    /** 検査項目コード */
    inspectionCode = ""
    /** 単価 */
    price = 0

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<ProductPrice>) {
        Object.assign(this, init)
    }
}
